import Vue from 'vue'
import Vuex from 'vuex'
import * as entry from '@/store/modules/entry.js'
import * as auth from '@/store/modules/auth.js'
import * as user from '@/store/modules/user.js'
import * as photo from '@/store/modules/photo.js'
import * as notification from '@/store/modules/notification.js'
import * as admin from '@/store/modules/admin.js'
import * as review from '@/store/modules/review.js'
import * as judging from '@/store/modules/judging.js'
import * as shortlist from '@/store/modules/shortlist.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    entry,
    auth,
    user,
    photo,
    notification,
    admin,
    review,
    judging,
    shortlist
  },
  state: {
    open: false,
    currentUser: '',
    judgingOpen: false,
    config: {
      photoCount: 10,
      statementWordCount: 350,
      photoDim: {
        /*
        landscape: { width: 250, height: 120 },
        portrait: { width: 120, height: 250 },
        square: { width: 250, height: 250 }
         */
        landscape: { width: 2500, height: 1200 },
        portrait: { width: 1200, height: 2500 },
        square: { width: 2500, height: 2500 }
      },
      fileSize: 5000000
    }
  },
  mutations: {},
  actions: {},
  getters: {
    readableFileSize: () => (bytes, decimalPoint) => {
      if (bytes == 0) return '0 Bytes'
      var k = 1000,
        dm = decimalPoint || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    }
  }
})
